/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WriteConfigObject } from './WriteConfigObject';
import {
    WriteConfigObjectFromJSON,
    WriteConfigObjectFromJSONTyped,
    WriteConfigObjectToJSON,
} from './WriteConfigObject';

/**
 * 
 * @export
 * @interface WriteConfig
 */
export interface WriteConfig {
    /**
     * 
     * @type {{ [key: string]: WriteConfigObject; }}
     * @memberof WriteConfig
     */
    objects?: { [key: string]: WriteConfigObject; };
}

/**
 * Check if a given object implements the WriteConfig interface.
 */
export function instanceOfWriteConfig(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WriteConfigFromJSON(json: any): WriteConfig {
    return WriteConfigFromJSONTyped(json, false);
}

export function WriteConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): WriteConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'objects': !exists(json, 'objects') ? undefined : (mapValues(json['objects'], WriteConfigObjectFromJSON)),
    };
}

export function WriteConfigToJSON(value?: WriteConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'objects': value.objects === undefined ? undefined : (mapValues(value.objects, WriteConfigObjectToJSON)),
    };
}

